import * as PIXI from 'pixi.js';
import GSOParasite from '../../../Game/Base/GSOParasite';
import Global from '../../../Game/Global';
import Vector from '../../../Game/Base/Math/Vector';
import Angle from '../../../Game/Base/Math/Angle';
import { Shape } from '../../../Game/Level/Blok';
import MoveToCanvasButton from '../../MoveToCanvasButton';
import { MovementBehaviour, ResizeBehaviour, RotationBehaviour } from '../../shared';
import LineVisuals from './LineVisuals';
import AssetManager from '../../../Game/Base/AssetManager';

export default class SelectedActieReactieOverlay extends GSOParasite {
    constructor(realParent, stepParent) {
        super(realParent, stepParent);

        this.pixiContainer = null;
        this.pixiGraphics = null;

        this.forwardToLine = new LineVisuals(this, AssetManager.get('img.reaction_forward'));
        this.forwardToLine.speed = 2;
        this.forwardToLine.size = 32;
        this.forwardToLine.disable();
    }

    onCreateVisuals() {
        this.pixiContainer = new PIXI.Container();
        this.getParentPixiContainer().addChild(this.pixiContainer);

        this.pixiGraphics = new PIXI.Graphics();
        this.pixiContainer.addChild(this.pixiGraphics);

        const actieReactie = this._realParent.getSelectedStateActieReactie();
        if (actieReactie.passOnReaction) {
            this.onUpdatePassOnReaction();
        }
    }

    onUpdateVisuals() {
        const blok = this.getAttachedStepParent();
        this.pixiContainer.rotation = -blok.rotation;
        this.pixiGraphics.rotation = blok.rotation;

        this.pixiGraphics.clear();
        const lineThickness = 4;
        this.pixiGraphics.lineStyle(lineThickness + 0.1, 0x004e2ea);
        if (blok.shape === Shape.rectangle) {
            this.pixiGraphics.drawRect(
                (-blok.size.x * Global.NATIVE_BLOCK_SIZE) / 2 + lineThickness / 2,
                (-blok.size.y * Global.NATIVE_BLOCK_SIZE) / 2 + lineThickness / 2,
                blok.size.x * Global.NATIVE_BLOCK_SIZE - lineThickness,
                blok.size.y * Global.NATIVE_BLOCK_SIZE - lineThickness
            );
        } else {
            this.pixiGraphics.drawCircle(0, 0, (blok.size.x * Global.NATIVE_BLOCK_SIZE - lineThickness) / 2);
        }

        if (this._realParent.selectingBlokForActieReactie) {
            this.onUpdatePassOnReaction(this._realParent.getHoveredBlok());
        }
    }

    onUpdatePassOnReaction(blok = 10) {
        const thisBlok = this.getAttachedStepParent();
        const actieReactie = this._realParent.getSelectedStateActieReactie();

        let otherBlok = blok;
        if (blok === 10) otherBlok = this._realParent.levelEditor.level.blokken.findByUUID(actieReactie.passOnReaction);

        if (this.forwardToLine._enabled && (!otherBlok || otherBlok === thisBlok || otherBlok.isPlayer)) {
            this.forwardToLine.disable();
        }
        if (!this.forwardToLine._enabled && otherBlok && otherBlok !== thisBlok && !otherBlok.isPlayer) {
            this.forwardToLine.enable();
            this.forwardToLine._gsoCreateVisuals();
        }
        if (otherBlok) {
            this.forwardToLine.to = otherBlok.position.sub(this._gsoParent.position);
        }
    }

    onDestroyVisuals() {
        this.pixiContainer.destroy();
        this.pixiGraphics.destroy();
    }

    onAttach() {}

    onDetach() {
        this.forwardToLine.disable();
    }
}
